import React from "react";
import swal from "sweetalert";

function DeleteVisitaButton({ id, deleteVisita, setVisitas }) {
  function confirmDelete(id) {
    swal({
      title: "Eliminar la Visita?",
      icon: "error",
      buttons: {
        cancel: "Cancelar",
        catch: "Eliminar",
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteVisita(id).then(() => {
          swal("Visita eliminada", {
            button: false,
            icon: "success",
            timer: "1500",
          });
          setVisitas((prevState) =>
            prevState.filter((visita) => visita.id_visita !== id)
          );
        });
      }
    });
  }

  return (
    <button
      className="btn btn-danger btn-sm btn-block m-1"
      onClick={() => confirmDelete(id)}
    >
      Eliminar
    </button>
  );
}

export default DeleteVisitaButton;
